import React from "react";

// SVG Icons
const BrainIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z" />
    <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z" />
  </svg>
);

const IntegrationIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 4H6" />
    <path d="M6 20h12" />
    <path d="M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" />
    <path d="M12 12v8" />
    <path d="M12 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8z" />
  </svg>
);

const SecurityIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);

const ChartIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 3v18h18" />
    <path d="m18 17-2-2-4 4-3-3-3 3" />
    <path d="M14 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
    <path d="M6 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
  </svg>
);

// Feature data with expanded descriptions
export const featureSections = [
  {
    icon: <BrainIcon />,
    title: "AI That Thinks Like a Strategist",
    description: "AI that captures key insights, not just records",
    features: [
      {
        label: "Automated Decision Tracking:",
        desc: "Identifies key decisions, action items, and owners in real time—no manual sifting.",
      },
      {
        label: "Sentiment Analysis:",
        desc: "Detects team consensus, conflicts, or hesitation to flag risks before they escalate.",
      },
      {
        label: "Smart Summaries:",
        desc: "Generates TL;DRs for executives and detailed recaps for stakeholders—all tailored to the audience.",
      },
    ],
    gap: "Others stop at transcription. MeetMinutes delivers insights, not just ink."
  },
  {
    icon: <IntegrationIcon />,
    title: "Seamless Workflow Integration",
    description: "Sync to your favorite tools with one click",
    features: [
      {
        label: "One-Click Sync:",
        desc: "Push tasks directly to Jira, Asana, Trello, or Slack. Turn meeting notes into tickets in seconds.",
      },
      {
        label: "Custom Templates:",
        desc: "Design branded templates for sales calls, sprint retrospectives, or board meetings.",
      },
      {
        label: "Live Collaboration:",
        desc: "Edit notes with teammates in real time, add comments, and assign tasks without leaving the app.",
      },
    ],
    gap: "Competitors silo notes. MeetMinutes connects to your tools, closing the loop between talk and action."
  },
  {
    icon: <SecurityIcon />,
    title: "Enterprise-Grade Security",
    description: "Keep your data secure and controlled",
    features: [
      {
        label: "Zero Data Training:",
        desc: "Your meetings never train public AI models (unlike many competitors).",
      },
      {
        label: "SOC 2 & PIPEDA Compliant:",
        desc: "End-to-end encryption, role-based access, and Canadian data residency options.",
      },
      {
        label: "Custom Retention Policies:",
        desc: "Auto-delete sensitive recordings or archive critical decisions on your terms.",
      },
    ],
    gap: "Others treat security as an afterthought. For MeetMinutes, it's the foundation."
  },
  {
    icon: <ChartIcon />,
    title: "Built for Outcomes",
    description: "Track decisions and action items at a glance",
    features: [
      {
        label: "Decision Dashboard:",
        desc: "Track action-item completion rates, follow-up deadlines, and ROI on meeting time.",
      },
      {
        label: "Auto-Follow-Ups:",
        desc: "Schedule reminders, share summaries, and nudge owners via email or Slack.",
      },
      {
        label: "Analytics Suite:",
        desc: "Measure meeting effectiveness (tracking time spent relative to decisions made) to optimize workflows.",
      },
    ],
    gap: "Competitors count words. MeetMinutes measures impact."
  },
];

// Stats data
export const stats = [
  { value: "83%", label: "Less time spent on meeting notes" },
  { value: "92%", label: "Increase in action item completion" },
  { value: "2.5x", label: "Better decision follow-through" }
]; 